<template>
    <div class="h-full flex flex-col bg-white">
        <div class="sticky top-0 z-50 bg-white w-full h-[88px] border-b border-gray-DFDFDF px-[20px] lg:px-[40px] flex items-center justify-center">
            <h2 class="font-semibold leading-none font-oceanside">
                {{ currentGroup }}
            </h2>
            <button
                type="button"
                class="absolute right-[20px] lg:right-[40px] focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2"
                :aria-label="$t('COLOR_CHANGE_CONFIRM_CLOSE')"
                @click="closePanel"
            >
                <img src="../assets/images/icons/close.svg" class="w-[18.84px] h-auto" alt="" />
            </button>
        </div>

        <div class="h-[56px] border-b border-gray-DFDFDF px-[20px] lg:px-[40px] flex items-center justify-center">
            <div class="font-semibold leading-none font-oceanside text-center truncate">
                {{ previewOptionLabel }}
            </div>
        </div>

        <div class="flex-1 flex items-center justify-center overflow-hidden">
            <img
                v-if="previewOptionImage"
                :src="previewOptionImage"
                class="w-full h-full object-contain md:max-w-[80vw] max-h-[35vh]"
                :style="previewImageStyle"
                :alt="previewOptionLabel"
            />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import getImage from '../helpers/getimage';

    export default {
        mixins: [allStores],

        props: {
            itemData: {
                type: Object,
                required: true,
            },

            isDirty: {
                type: Boolean,
                default: false,
            },

            payload: {
                type: Object,
                default: null,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            previewOption() {
                return this.payload?.option ?? null;
            },

            previewOptionLabel() {
                const label = this.previewOption?.label;

                if (label === 'No Thanks') {
                    return 'Stock Paintfill';
                }

                return label || '';
            },

            previewOptionImage() {
                const option = this.previewOption;

                if (!option) {
                    return '';
                }

                return getImage(this.viewController, option.raw ?? option);
            },

            previewImageStyle() {
                const percent = Number(this.payload?.imageSizePercent);
                const zoomPercent = Number.isFinite(percent) && percent > 0 ? percent : 100;
                const zoomScale = zoomPercent / 100;

                return {
                    transform: `scale(${zoomScale})`,
                    transformOrigin: 'center center',
                };
            },
        },

        methods: {
            closePanel() {
                this.appStore.closeNestedPanel();
            },

            handleApplySelections() {
                this.closePanel();
            },
        },
    };
</script>
